
<template>
    <div class="container-fluid">
        <div class="col-md-12">
            <p><b>Nom :</b> {{ adh.fullname }}</p>
            <p><b>Portable :</b> <a :href="`tel:${adh.mobile}`"> {{ adh.mobile }}</a></p>
            <p><b>Fixe :</b> <a :href="`tel:${adh.tel}`"> {{ adh.tel }}</a></p>
            <p><b>Adresse mail :</b> <a :href="`mailto:${adh.email}`"> {{ adh.email }}</a></p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'AdhInfo',
    components: {
        
    },
    props: {
        adh_id: {
            type: Number,
            required: true,
            default: function () {
                return {
                    id: 1
                }
            }
        },
        adh_sms: {
            type: String,
            required: false,
            default: function () {
                return {
                    sms: ""
                }
            }
        }
    },
    data () {
        return {
            adh :{
                fullname : "",
                mobile : "",
                tel : "",
                email : "",
            }
        };
    },
    computed: {
        ...mapGetters({
            adherentById: 'adherents/adherentById',
        })
    },
    mounted() {
        if(this.adh_id != 1){
		    this.adh = this.adherentById(this.adh_id);
        }
        else{
            this.adh.mobile = this.adh_sms;
        }
    },
    methods: {
        
        show(adh) {
            this.adh_info=adh;
        },

        closeModal(e) {
            // Prevent modal from closing
            e.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
        },
    },
};
</script>